import { render } from "./settlement_pause.vue?vue&type=template&id=6a22555b&ts=true"
import script from "./settlement_pause.vue?vue&type=script&lang=ts"
export * from "./settlement_pause.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/garyfang/Documents/Projects/vue/boxing_frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__